// IM-XPR-001 (IM-ADR-015) — Escolha da experiência pela chave EXPERIENCE_V2_ENABLED. Desligada: shell, início e
// rotas exatamente como antes (rotas novas = "Página não encontrada"). Ligada: shell novo e tela Hoje no início; as
// rotas antigas continuam as mesmas.
import type { ReactNode } from 'react';
import { AppShell } from '../components/AppShell';
import { NotFound } from '../pages/NotFound';
import { Overview } from '../pages/Overview';
import { useExperience } from './ExperienceContext';
import { ShellV2 } from './ShellV2';
import { Today } from './Today';

/** Enquanto a interface não sabe qual experiência montar, nenhum dos dois shells aparece (sem piscar). */
export function ShellSwitch() {
  const xp = useExperience();
  if (!xp.ready) return <div className="sr-only" role="status">Carregando…</div>;
  return xp.v2 ? <ShellV2 /> : <AppShell />;
}
export function HomeSwitch() { return useExperience().v2 ? <Today /> : <Overview />; }
export function V2Only({ children }: { children: ReactNode }) { return useExperience().v2 ? <>{children}</> : <NotFound />; }
